<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="card-body justify-content-between">

      <div class="filtros-body">
        <div class="row">
          <!-- Datos del cliente -->
          <div class="col">



            <div [ngClass]="{'row': true, disabledContent: !enableClient}">
              <ng-container *ngIf="permiteUnidadNegocio">
                <div [ngClass]="{disabledContent: !enableClient}">
                  <div class="col">
                    <div class="md-form">
                      <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                        placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                      </mdb-select>
                      <div *ngIf="
                                              formHeader.get('unidad_negocio_codigo').invalid &&
                                              (formHeader.get('unidad_negocio_codigo').dirty ||
                                              formHeader.get('unidad_negocio_codigo').touched)
                                            ">
                        <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                          de negocio
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div class="col" style="max-width: 170px;">
                <!-- <Strong class="title">RUT Cliente</Strong>
                <span class="value" *ngIf="headerData?.clienteSeleccionado">
                  {{ headerData?.clienteSeleccionado.rutFormato | rut }}
                </span> -->
                <div class="md-form">
                  <input value="" type="text" id="rutcliente" class="form-control" placeholder="" required #rutcliente
                    formControlName="rutCliente" formatRut />
                  <label for="rutcliente">RUT</label>
                  <div *ngIf="
                            formHeader.get('rutCliente').invalid &&
                            (formHeader.get('rutCliente').dirty ||
                            formHeader.get('rutCliente').touched)
                        ">
                    <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">
                      Ingrese rut cliente
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarCliente()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" *ngIf="headerData?.clienteSeleccionado; else mjsConsultaRut"
                  style="display: contents;">
                  {{ headerData?.clienteSeleccionado.razon_social }}
                </h6>
                <ng-template #mjsConsultaRut>
                  <h6 class="text-info" style="display: contents;">Ingrese el RUT del cliente</h6>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form" style="max-width: 200px;">
                  <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar sucursal"
                    [filterEnabled]="true" formControlName="sucursal"></mdb-select>
                  <div *ngIf="
                                                                          formHeader.get('sucursal').invalid &&
                                                                          (formHeader.get('sucursal').dirty ||
                                                                          formHeader.get('sucursal').touched)
                                                                        ">
                    <mdb-error *ngIf="formHeader.get('sucursal').hasError('required')">Ingrese sucursal
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col dato">
                <Strong class="title">Comuna</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{ headerData.direccion.nombreComuna
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato">
                <Strong class="title">Región</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{ headerData.direccion.nombreRegion
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato">
                <Strong class="title">Dirección</Strong>
                <span class="value" *ngIf="headerData?.direccion; else dummyTxt">{{
                  headerData.direccion.direccion_completa }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Condición de pago" [options]="optionsCondicionPago"
                    placeholder="Seleccionar condición de pago" [filterEnabled]="true" formControlName="condicionPago">
                  </mdb-select>
                  <div *ngIf="
                    formHeader.get('condicionPago').invalid &&
                    (formHeader.get('condicionPago').dirty ||
                    formHeader.get('condicionPago').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('condicionPago').hasError('required')">Ingrese condición de pago
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                    [filterEnabled]="true" formControlName="vendedor"></mdb-select>
                  <div *ngIf="
                                  formHeader.get('vendedor').invalid &&
                                  (formHeader.get('vendedor').dirty ||
                                  formHeader.get('vendedor').touched)
                                ">
                    <mdb-error *ngIf="formHeader.get('vendedor').hasError('required')">Ingrese vendedor
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>


          </div>

          <!-- Datos de factura -->
          <div class="col">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-date-picker #datePicker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Doc.'" required
                    formControlName="fechaFactura">
                  </mdb-date-picker>
                  <div *ngIf="
                    formHeader.get('fechaFactura').invalid &&
                    (formHeader.get('fechaFactura').dirty ||
                    formHeader.get('fechaFactura').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('fechaFactura').hasError('required')">Ingrese fecha
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col dato">
                <Strong class="title">Fecha de vencimiento</Strong>
                <!-- <span class="value" *ngIf="headerData?.fechaVencimiento">{{ headerData.fechaVencimiento | date }}</span> -->
                <span class="value" *ngIf="headerData?.fechaVencimiento; else dummyTxt">{{ headerData.fechaVencimiento |
                  fecha
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato">
                <Strong class="title">Lista de precios</Strong>
                <span class="value" *ngIf="headerData?.clienteSeleccionado; else dummyTxt">
                  {{ headerData?.clienteSeleccionado.lista_precio_codigo }}
                </span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col" style="min-width: 350px; display: flex; align-items: center;">
                {{formHeader.value | json}}
              </div>
            </div> -->

            <div class="row">
              <div class="col" style="min-width: 350px; display: flex; align-items: center;">
                <!-- Material inline 1 -->
                <div class="form-check form-check-inline" style="margin-right: 20px;">
                  <input type="radio" class="form-check-input" mdbInput id="factura_afecta" [value]="FACTURA_AFECTA"
                    formControlName="facturaAfectaOrExcenta" />
                  <label class="form-check-label" for="factura_afecta">Afecta</label>
                </div>

                <!-- Material inline 2 -->
                <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input" mdbInput id="factura_excenta" [value]="FACTURA_EXCENTA"
                    formControlName="facturaAfectaOrExcenta" />
                  <label class="form-check-label" for="factura_excenta">Exenta</label>
                </div>
              </div>

              <div class="col" style="display: flex; align-items: center; min-width: 240px;">
                <!-- Switch -->
                <div class="switch danger-switch">
                  <label>
                    <input type="checkbox" formControlName="incluirEnRecorrido" />
                    <span class="lever"></span>
                    Incluir en recorrido
                  </label>
                </div>
              </div>
            </div>

            <div class="row filtros-header mt-1 p-0" style="justify-content: start; align-items: center;">
              <div class="col">
                <h4>
                  Descuentos y recargos
                </h4>
              </div>
            </div>
            <div class="filtros-body" [ngClass]="{disabledContent: !enableClient}">
              <!-- DESCUENTO -->
              <div class="row mb-2" formGroupName="descuento">
                <div class="col" style="max-width: 100px; display: flex; align-items: center;">
                  <h5>Descuento</h5>
                </div>

                <div class="col dcto-box">
                  <div class="">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">%</div>
                      </div>
                      <input mdbInput type="text" id="descuentoPorcent" class="form-control py-0" #descuentoPorcent
                        decimales formControlName="porcentaje">
                      <div *ngIf="formHeader.get('descuento.porcentaje').invalid &&
                                                        (formHeader.get('descuento.porcentaje').dirty ||
                                                        formHeader.get('descuento.porcentaje').touched)
                                                      ">
                        <!-- <mdb-error
                          *ngIf="formHeader.get('descuento.porcentaje').hasError('min') || formHeader.get('descuento.porcentaje').hasError('max')">
                          Valor no válido
                        </mdb-error> -->
                        <mdb-error
                          *ngIf="formHeader.get('descuento.porcentaje').hasError('max') && headerData.clienteSeleccionado && headerData.clienteSeleccionado.descuento_maximo">
                          Valor no puede ser mayor a {{headerData.clienteSeleccionado.descuento_maximo }}
                        </mdb-error>
                      </div>
                    </div>

                  </div>
                </div>



                <div class="col dcto-box">
                  <div class="">

                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <input mdbInput type="text" id="descuentoPesos" class="form-control py-0" #descuentoPesos monto
                        formControlName="monto">
                      <!-- <div *ngIf="
                                                        formHeader.get('descuento.monto').invalid &&
                                                        (formHeader.get('descuento.monto').dirty ||
                                                        formHeader.get('descuento.monto').touched)
                                                      ">
                        <mdb-error *ngIf="formHeader.get('descuento.monto').hasError('min')">Valor debe ser mayor
                          a 0
                        </mdb-error>
                      </div> -->
                    </div>

                  </div>
                </div>




                <div class="col">
                  <div class="row">
                    <div class="col p-0">
                      <!-- Material inline 1 -->
                      <div class="form-check form-check-inline" style="margin-right: 10px;">
                        <input type="radio" class="form-check-input" mdbInput id="descuento_item_afecto"
                          [value]="DESCUENTO_ITEM_AFECTO" formControlName="afectoOrExcento" />
                        <label class="form-check-label" for="descuento_item_afecto">Items afectos</label>
                      </div>
                    </div>
                    <div class="col p-0">
                      <!-- Material inline 2 -->
                      <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" mdbInput id="descuento_item_excento"
                          [value]="DESCUENTO_ITEM_EXCENTO" formControlName="afectoOrExcento" />
                        <label class="form-check-label" for="descuento_item_excento">Items exentos</label>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

              <!-- RECARGOS -->
              <div class="row" formGroupName="recargo">
                <div class="col" style="max-width: 100px; display: flex; align-items: center;">
                  <h5>Recargo</h5>
                </div>
                <div class="col dcto-box">
                  <div class="">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">%</div>
                      </div>
                      <input mdbInput type="text" id="recargoPorcent" class="form-control py-0" #recargoPorcent
                        decimales formControlName="porcentaje">
                      <!-- <div *ngIf="
                                                                              formHeader.get('recargo.porcentaje').invalid &&
                                                                              (formHeader.get('recargo.porcentaje').dirty ||
                                                                              formHeader.get('recargo.porcentaje').touched)
                                                                            ">
                        <mdb-error *ngIf="formHeader.get('recargo.porcentaje').hasError('min')">Valor debe ser
                          mayor a 0
                        </mdb-error>
                      </div> -->
                    </div>

                  </div>
                </div>
                <div class="col dcto-box">
                  <div class="">

                    <div class="input-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">$</div>
                      </div>
                      <input mdbInput type="text" id="recargoPorcent" class="form-control py-0" #recargoPorcent monto
                        formControlName="monto">
                      <!-- <div *ngIf="
                                                                              formHeader.get('recargo.monto').invalid &&
                                                                              (formHeader.get('recargo.monto').dirty ||
                                                                              formHeader.get('recargo.monto').touched)
                                                                            ">
                        <mdb-error *ngIf="formHeader.get('recargo.monto').hasError('min')">Valor debe ser mayor a
                          0
                        </mdb-error>
                      </div> -->
                    </div>

                  </div>
                </div>

                <div class="col">
                  <div class="row">
                    <div class="col p-0">
                      <!-- Material inline 1 -->
                      <div class="form-check form-check-inline" style="margin-right: 20px;">
                        <input type="radio" class="form-check-input" mdbInput id="recargo_item_afecto"
                          [value]="RECARGO_ITEM_AFECTO" formControlName="afectoOrExcento" />
                        <label class="form-check-label" for="recargo_item_afecto">Items afectos</label>
                      </div>
                    </div>
                    <div class="col p-0">
                      <!-- Material inline 2 -->
                      <div class="form-check form-check-inline">
                        <input type="radio" class="form-check-input" mdbInput id="recargo_item_excento"
                          [value]="RECARGO_ITEM_EXCENTO" formControlName="afectoOrExcento" />
                        <label class="form-check-label" for="recargo_item_excento">Items exentos</label>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="row">
          <div class="col-1">
            <button mdbBtn type="button" class="" color="secondary" mdbWavesEffect (click)="abrirModalDocsReferencia()"
              [disabled]="formHeader.get('rutCliente').value == '' || formHeader.get('rutCliente').value == null">
              <mdb-icon fas icon="file"></mdb-icon>
              doc ref.
            </button>
          </div>
          <div class="col">
            <h6 class="text-info" *ngIf="CountListDocRef > 0" style="margin-top: 1%;">
              {{CountListDocRef}} doc Seleccionado
            </h6>
          </div>
        </div>
        <!-- FIN/ FILA #2 -->
      </div>


    </div>
  </form>
</div>


<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>

<app-modal-docs-referencia (onCountListDocRef)="getCountListDocRef($event)"></app-modal-docs-referencia>